// extracted by mini-css-extract-plugin
module.exports = {"code":"dSIHscript_code__eFnV_"};